import { Box } from '@mui/material';
import { useStyles } from './CaseNotes.styles';
import { btnType, Button } from '../../../../atoms/button';
import { iconBtnPosition, iconBtnType, IconButton } from '../../../../molecules/icon-button';
import clsx from 'clsx';
import { NoteStyle } from '../../../../../constants/CommonConstants';
import { NoteCard } from '../../../note-card';
import { NoteIcons } from '../../../../../../constants/CommonConstants';
import LottieTodo from '../../../../../icons/lotties/lottieIcons/TodoList';
import { fontWeight, Text, textLevel } from '../../../../atoms/typography';
import { colors } from '../../../../../colors';

const CaseNotes = ({ onAddNoteClick, caseNotes = [], caseNotesRecommendations, onChatClick, onDiscardRecommendation, appointmentId, fetchNotesRecommendations, onNoteClick, onRecommendationClick, onReasoningClick }) => {
  const baseClasses = useStyles({ status: NoteStyle.GENERAL });

  const filteredNotes = caseNotes.map(item => ({ ...item, patientId: '' }));
  const filteredNotesRecommendations = caseNotesRecommendations.map(item => ({ ...item, patientId: '' }));

  const renderEmptyState = () => {
    return (
      <Box display="flex" flexDirection="column" gap="16px">
        <Box display="flex" gap="8px" alignItems="center">
          <Box width={80} maxWidth={80} maxHeight={80}>
            <LottieTodo />
          </Box>
          <Box display="flex" flexDirection="column" gap="4px">
            <span className={baseClasses.bodyUuid}>We handle your admin tasks</span>
            <span className={baseClasses.bodyServiceName}>
              Need help with something? Let care navigation know.
            </span>
          </Box>
        </Box>
      </Box>
    );
  };

  const renderCaseNoteCard = () => {
    return (
      <Box display="flex" flexDirection="column" width="100%" height="100%">
        {filteredNotesRecommendations.map((note, index) => (
          <NoteCard
            key={index}
            note={note}
            icon={NoteIcons[note.type]}
            isRecommendation={true}
            onDiscard={() => onDiscardRecommendation?.(note._id)}
            appointmentId={appointmentId}
            fetchNotesRecommendations={fetchNotesRecommendations}
            onConfirmClick={() => onRecommendationClick?.(note)}
            fetchRecommendations={fetchNotesRecommendations}
            onReasoningClick={onReasoningClick}
          />
        ))}
        {filteredNotes.map((note, index) => (
          <NoteCard
            key={index}
            note={note}
            icon={NoteIcons[note.flag]}
            onClick={() => onNoteClick?.(note)}
          />
        ))}
      </Box>
    );
  };

  return (
    <Box className={baseClasses.wrapper}>
      <Box className={baseClasses.sectionTitle}>
        <Text weight={fontWeight.SEMI_BOLD} color={colors.neutral900} className={baseClasses.title}>
          Case notes
        </Text>
        <Text level={textLevel.M} weight={fontWeight.MEDIUM} color={colors.neutral600} className={baseClasses.subtitle}>
          We handle your admin tasks. Need help with something? Let care navigation know.
        </Text>
      </Box>
      <Box className={baseClasses.container}>
        <Box className={baseClasses.header}>
          <Box>Case notes</Box>
        <Box>
          <IconButton
            className={baseClasses.addBtn}
            icon="plus"
            variant={iconBtnType.TEXT}
            onClick={onAddNoteClick}
            iconPosition={iconBtnPosition.LEFT}
          >
            Add new
          </IconButton>
        </Box>
      </Box>
      <Box
        className={clsx(baseClasses.body, {
          [baseClasses.medicationBody]: caseNotes.length || caseNotesRecommendations.length !== 0,
        })}
      >
        {caseNotes.length === 0 && caseNotesRecommendations.length === 0 ? renderEmptyState() : renderCaseNoteCard()}
      </Box>
      <Box className={baseClasses.footer}>
        <span className={baseClasses.footerText}>Need to discuss this with the Care Team?</span>
        <Button className={baseClasses.footerBtn} variant={btnType.TEXT} onClick={onChatClick}>
          Go to care team chat
        </Button>
      </Box>
      </Box>
    </Box>
  );
};

export { CaseNotes };
